import TimelineLite from 'gsap/TimelineLite';
import intersectionHelper from '../../../general/js/intersection-helper';
import BaseComponent from '../../../general/js/base-component';

export default class UpcomingAuctionsComponent extends BaseComponent {
    constructor() {
        super(...arguments);
        this.auctions = this.refs.auctions;

        this.init();
    }

    init() {
        this.timeline = new TimelineLite({paused: true});
        this.timeline.staggerFrom(this.auctions, 0.4, {opacity: 0, left: '-80px', delay: 0.3}, 0.3);
        intersectionHelper.enterViewportOnce(this.element, this.render.bind(this));
    }

    render() {
        this.timeline.play();
    }
}



// WEBPACK FOOTER //
// ./app/components/upcoming-auctions/js/upcoming-auctions.component.js